import { nav, stepDeltaToDirection } from 'constants/scriptFlow';
import { get } from 'lodash';

export const getStepNumber = (state) => state.scriptFlow.activeStep.stepNumber;
export const getNumStepActions = (state) => get(state, 'scriptFlow.stepActions.length', 2); // Includes exit steps.
export const getNumSteps = (state) => getNumStepActions(state) - 2; // Excludes exit steps.
export const isFirstStep = (state) => getStepNumber(state) === 1; // Step 0 is reserved for exiting the script flow going backard.
export const isLastStep = (state) => getStepNumber(state) === getNumStepActions(state) - 2; // Step N-1 is reverved for exiting the script flow going forward.
export const isLastExperimentStep = (state) => getStepNumber(state) === getNumStepActions(state) - 1; // Step N-1 is reverved for exiting the script flow going forward.
export const isScriptFlowActive = (state) => getNumStepActions(state) > 0;
export const getStepAction = (state, stepNumber) => state.scriptFlow.stepActions[stepNumber];
export const getStepTitleTextKey = (state) => state.scriptFlow.activeStep.titleTextMessageKey;

export const getDirectionToStep = (state, stepNumber) => {
  let fromStepNumber = getStepNumber(state);
  const stepDelta = stepNumber - fromStepNumber;
  return stepDeltaToDirection[stepDelta] || nav.JUMP;
};

export const getStepNumberForDirection = (state, direction) => {
  let fromStepNumber = getStepNumber(state);
  const newStepNumber = (direction === nav.BACK) ? fromStepNumber - 1 : fromStepNumber + 1;
  return (newStepNumber >= 0 && newStepNumber < getNumStepActions(state))
    ? newStepNumber : null;
};
